import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner1-1920x450.jpg";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./JoinUsPage.scss";

const JoinUsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("contact_us_page_heading")}</h1>
          <p className="banner-subtitle">{t("join_us_page_heading2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_contact_us_page_link1")}</Link>
        <span>{t("breadcrumbs_contact_us_page_span")}</span>
        <Link>{t("join_us_page_heading2")}</Link>
      </Breadcrumbs>
      
      <main className="join-us-main-container">
        <section className="join-us-content-section">
          <div className="join-us-text-container">
            <p className="join-us-default-text">
              {t("join_us_page_default_text")}
            </p>
          </div>
        </section>
      </main>
      
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>
     
      <Footer />
    </>
  );
};

export default JoinUsPage;
